import { Group1Schema, Group1Schema as menuItem} from '../../models/Group1Items';
import { NavDropdownMenu,DropdownSubmenu } from 'react-bootstrap-submenu';
import { NavDropdown } from "react-bootstrap";
import { useEffect, useState } from 'react';
import 'react-bootstrap-submenu/dist/index.css';
import { Link } from 'react-router-dom';
import { Group2Schema } from '../../models/Group2Items';

interface NavProductCategoriesProps {
    menuData: Group1Schema[],
    submenuData: Group2Schema[],
};
const NavProductCategories = ({ menuData, submenuData }: NavProductCategoriesProps) => {

    const [menuWithSubmenu, setMenuWithSubmenu] = useState<menuItem[]>([]);

    useEffect(() => {
    const menuWithSubmenu = menuData.map(menuItem => ({
        ...menuItem,
        submenu: submenuData.filter(submenuItem => submenuItem.GRP1 === menuItem.CODE)
    }));
    setMenuWithSubmenu(menuWithSubmenu);
    },[menuData, submenuData]);

    return (
            <NavDropdownMenu title="Κατηγορίες" id="collasible-nav-dropdown">
                {menuWithSubmenu.map(menuItem => (
                <DropdownSubmenu href="" key={menuItem.CODE} title={menuItem.NAME}>
                    {menuItem.submenu?.map(submenuItem => (
                        <NavDropdown.Item as={Link} to={`/g2/${submenuItem.ID}`} state={{ g1ParentName: menuItem.NAME , g1ParentId: menuItem.CODE, g2ParentName: submenuItem.NAME, g2ParentId: submenuItem.ID }} key={submenuItem.CODE}>{submenuItem.NAME}</NavDropdown.Item>
                    ))}
                </DropdownSubmenu>
            ))}
            </NavDropdownMenu>
    );
}
export default NavProductCategories;